import {IFilterCategoryDefinition} from "../interfaces/filter-category-definition.interface";
import {IGameFilterDefinition} from "../interfaces/game-filter-definition.interface";
import {GameGroupFilter} from "../filters-definitions/game-group.filter";
import {CustomFilter} from "../filters-definitions/custom.filter";
import {SubgroupNameFilter} from "../filters-definitions/subgroup-name.filter";
import {AllRouletteFilter} from "../filters-definitions/all-roulette.filter";
import {AllBlackjackFilter} from "../filters-definitions/all-blackjack.filter";
import {AllBaccaratFilter} from "../filters-definitions/all-baccarat.filter";
import {AllPokerFilter} from "../filters-definitions/all-poker.filter";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {GameInfo} from "../../games/game-info";
import {OR} from "../evaluators/or-game-filters-evaluator";
import {ApplyGameFilterResult} from "../interfaces/game-filter-evaluator.interface";

export class GameGroupFiltersCategory implements IFilterCategoryDefinition {
    constructor(private readonly services: IServiceFactoryExtended) {
    }


    readonly title: string = 'Game Groups';

    applyFilters(gameInfo: GameInfo, filters: IGameFilterDefinition[]): ApplyGameFilterResult {
        return OR(...filters).applyFilter(gameInfo);
    }

    readonly availableFilters: IGameFilterDefinition[] = [
        new GameGroupFilter('roulette', 'Roulette'),
        new GameGroupFilter('blackjack', 'Blackjack'),
        new GameGroupFilter('baccarat', 'Baccarat'),
        new GameGroupFilter('videoPoker', 'VideoPoker'),
        new GameGroupFilter('keno','Keno'),
        new GameGroupFilter('craps', 'Craps'),
        new GameGroupFilter('slots', ['Slot','VideoSlot']),
        new CustomFilter('poker', (game) => game.gameGroup.toLowerCase().indexOf('poker') !== -1),
        new SubgroupNameFilter('live-poker', 'poker'),
        new SubgroupNameFilter('live-blackjack', 'blackjack'),
        new SubgroupNameFilter('live-roulette', 'roulette'),
        new SubgroupNameFilter('live-baccarat', 'baccarat'),
        new SubgroupNameFilter('live-game-shows','shows'),
        new CustomFilter('live-elite-lounge', (game) => game.isEliteLounge),
        new CustomFilter('live-elite-lounge-or-exclusive', (game) => game.isEliteLounge || game.isExclusiveGame),
        new AllRouletteFilter(),
        new AllBlackjackFilter(),
        new AllBaccaratFilter(),
        new AllPokerFilter(),
        new GameGroupFilter('scratchCards', 'Scratch Card')
    ]
}